import React, { Component, forwardRef } from 'react';
import { createPortal } from 'react-dom';
import ReactResizeDetector from 'react-resize-detector';
import { Placement } from '@philips-internal/oswald-ui-constants';
import { arrayOf, bool, element, func, number, object, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { CloseEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, isDefined, isEnumValid } from '@philips-internal/oswald-ui-utils';
class PopoverContent extends Component {
    constructor() {
        super(...arguments);
        this.onClick = (event, shouldClose = false) => {
            const { onClose, open } = this.props;
            if (open && shouldClose) {
                onClose && onClose(new CloseEvent());
            }
            event.stopPropagation();
        };
    }
    getClassName() {
        const { placement, className } = this.props;
        return classNames({
            'c-popover': true,
            [`c-popover--${placement}`]: isEnumValid(Placement, placement),
            [`${className}`]: Boolean(className),
        });
    }
    renderContent() {
        const { children, innerRef, maxHeight, onResize, padding, position, showArrow, title, width, zIndex } = this.props;
        const { arrow, guest } = position || {};
        const style = {
            maxHeight: isDefined(maxHeight) ? `${maxHeight}px` : undefined,
            padding,
            width: isDefined(width) ? `${width}px` : undefined,
        };
        const titleIdentifier = title ? `c-popover__title` : undefined;
        return (React.createElement("div", { "aria-labelledby": titleIdentifier, className: this.getClassName(), ref: innerRef, role: "dialog", style: { ...guest, zIndex } },
            React.createElement("div", { className: "c-popover__overlay", onClick: event => this.onClick(event, true) }),
            showArrow && React.createElement("div", { className: "c-popover__arrow", onClick: event => this.onClick(event), style: { ...arrow } }),
            React.createElement("div", { className: "c-popover__content u-scrollbar", onClick: this.onClick, style: style },
                React.createElement(ReactResizeDetector, { handleHeight: true, handleWidth: true, onResize: onResize }),
                title && React.createElement("div", { className: "c-popover__title", id: titleIdentifier }, MessageService.translate(title)),
                children)));
    }
    render() {
        const { document } = this.props;
        if (!document?.body) {
            return null;
        }
        const popoverManager = document.querySelector('.c-application__managers .c-popover-manager');
        return createPortal(this.renderContent(), popoverManager ?? document.body);
    }
}
PopoverContent.propTypes = {
    children: oneOfType([element, arrayOf(element)]),
    className: string,
    document: object,
    innerRef: func,
    maxHeight: number,
    onClose: func,
    onResize: func,
    open: bool,
    padding: number,
    placement: string,
    position: object,
    showArrow: bool,
    title: string,
    width: number,
    zIndex: number,
};
PopoverContent.defaultProps = {
    placement: Placement.BOTTOM,
    position: {},
    showArrow: true,
};
const popoverContentWithRef = forwardRef((props, ref) => {
    return React.createElement(PopoverContent, { ...props, innerRef: ref });
});
popoverContentWithRef.displayName = PopoverContent.name;
export default popoverContentWithRef;
//# sourceMappingURL=popover-content.js.map